
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index2iax1BtRZsS3yGXJGGvtgXNFuncjiL6Bcb1Sxsg8BukMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/index.vue?macro=true";
import { default as status_l1q14hKxzdn7qPYhSqz6AeqwoMryVrf8vsZ_7NULjMMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/status.vue?macro=true";
import { default as updatexxMeZrPvD7v82SMOPzWF_hA4P1ICEaYEQwacmDGsxxUMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/update.vue?macro=true";
import { default as changesvDOChmzRQz82XqflzjURk4Z81XneIcY_iWVLn0EM6g0Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/changes.vue?macro=true";
import { default as _404T0QBajQrJqUcCzNeMkUypaAxutI12gCtrnb4LyLPAN4Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/error/404.vue?macro=true";
import { default as _500q6QBDO_Dydra0zi9eUdveJDhT8ag48HdnXknsBQB834Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/error/500.vue?macro=true";
import { default as indexQZh_2RuNbXPLiZyMPnn3OfqTf4pK5_7LZp44IV06GrEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/faq/index.vue?macro=true";
import { default as indexrdm1lmiPwv_qfgQXpzd7l6jB7uwmX1FaX6syT4YF_D0Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/index.vue?macro=true";
import { default as indexVhgZKAGPL6F3zfjJrvP7atVDOjDorAALwL4efmRwydcMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/case/index.vue?macro=true";
import { default as settingZgarAePVT7p1hptJMlS0vsTHypa8cvQ0oWgDApMWhN0Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/setting.vue?macro=true";
import { default as index4oJAWTrTtjWmRBiOqhVn422tpeU2rKPXRElNYFpdXG4Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/index.vue?macro=true";
import { default as steammj3KLOvMd22QEFAZpL4v_qrtHSqkjF5E0ifycBgHA4sMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/login/steam.vue?macro=true";
import { default as index82qBXPZHzwXnhua90Xx_rUXEI3NqySEL1t0UqMkzrScMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/trend/index.vue?macro=true";
import { default as myI8Di_1wVBWtV_R1jWTDsEsC_bBB73kkgjkgcLwd_6NsMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/my.vue?macro=true";
import { default as _91type_93jd7HFrNXwBaR2worUhiji1ksZcU75eHlXYbwvhfNITsMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/terms/[type].vue?macro=true";
import { default as indexsxOL4AWghvyrRMTOq4_0PAC_sEPeIhIPdcBhoy3UicEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/hanging/index.vue?macro=true";
import { default as indexbT8L8UZ35b_T0NTxUx9hz_Cbdz6bSAMbLvIzHLYK9XkMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/index.vue?macro=true";
import { default as third_45bindDVwuU_DBS5rCojqVkGj_75sRN96GwV1fwy5w9KJYX2kMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/third-bind.vue?macro=true";
import { default as indextAnhAQyxI1pJPXq_hh_rG9CWMVopYMbXWsiy_OmK_KAMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/index.vue?macro=true";
import { default as indexrSjRIda8LwDSwZ7orxM0x4Luf9by2c__KsSmFzK81JYMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/index.vue?macro=true";
import { default as const312WofrGY_A8zRf2Pm_O0_i5Gve056BE5MhbPyaRjYEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/const.ts?macro=true";
import { default as indexvBHLC22tVS9if_3VbPYXxodBhon1jhnY7i__gjkkarIMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/index.vue?macro=true";
import { default as indexO_868lOxNfpR6f5BNF9ZxTv689eXgc6weanNQyC14qgMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/index.vue?macro=true";
import { default as bindSteam7Z0bSochdx18IxQPuih0WVsWGsBHJii2Cav_xYvs6j4Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/login/bindSteam.vue?macro=true";
import { default as indexKsg_SSV6UfNkXFGhTM2451mrErS7nmgwERBDyH7C6CsMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/index.vue?macro=true";
import { default as index2j4kBTvMLRX_QqkIkIDXwCRAOoBVHWdZ18mBf2nj3e8Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/index.vue?macro=true";
import { default as apil01uNTAkYqsVMBBxctjY4WRKkZa7olAbjtMnJ7D3pYoMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/api.vue?macro=true";
import { default as postD1q9H2cxR_veQgNFsfT4uNdJAnrtPdBJwncYFyTQ2nYMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/post.vue?macro=true";
import { default as favoriteYhhHvvxYjzzGk26KhdTGZ0QDwdFKkA0otKoTOYYSt54Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/favorite.vue?macro=true";
import { default as index_45xinyingbackup_It8ADkyfoAvIUex55fzUqzlmAbFgmi0gst3CTMfuEcMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/index-xinyingbackup.vue?macro=true";
import { default as _91steamId_93znHB9Ccad9Vq3tbmT0mRdcB7nRRYZvSv8R9SP5pako4Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/[steamId].vue?macro=true";
import { default as itemMfhWPyKq_AvJ2q_lrVQ9tdbvI_czBLwK_TRkvdNAT90Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/components/item.vue?macro=true";
import { default as steamNWSyaXgZuJcUxMOTnhLebjqIEPrDwy6I9XcQFv2xWvUMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/steam.vue?macro=true";
import { default as indexUO4kvFwwa_rJ_Xg4sWiehUKZjjWVIKGxuTqVUTFfaUEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/tracker/index.vue?macro=true";
import { default as alipayaxwaMaOcyr64V4dZOMsVmbXGqqI67af0_P5nWLFSI70Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/alipay.vue?macro=true";
import { default as sysMsgoh7ttaJlB_oQOchJLg86BvsuyFVIOvAlfoWP360Q0aEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/sysMsg.vue?macro=true";
import { default as item0fwHF6fxy2oLsk34G02xtWFPSOKm8QTXHh7Dv8N6Ir0Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/components/item.vue?macro=true";
import { default as likeMsgEo7kj7h_jDs2u7KhvrEoV4T_hdK5dZwLQ_0GCHLlMZkMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/likeMsg.vue?macro=true";
import { default as messagewdevlqHn4F3GpbZczb1J4smnDEki87TWX4AQwKFS0JoMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/message.vue?macro=true";
import { default as sideBarwEn3PC4_ewS1kibj887rCyUibHWX_nFtXRaaBT5YyAUMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/sideBar.vue?macro=true";
import { default as index5LQq5NtFeccL1BHrthFicgComMVKLPWCjqj6eGVFOP4Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/detail/index.vue?macro=true";
import { default as onlineh9m_pfAyI3YOe_R6PbcQiV7NwzjvTm27RRbLB7B0T7YMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/online.vue?macro=true";
import { default as postItemz0SUvI4KGgwSpAoAhTW4lW9wLE0xuiUTVIFTWULMut8Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/postItem.vue?macro=true";
import { default as _91marketHashName_93p_z3fpY6c6I4axPyixuhDWAzEZUlj_hkmt6OXoCFSB4Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/[marketHashName].vue?macro=true";
import { default as collectU_8hF7BdyYQc9Q88s5wAxWGvqPfet2_cI2m05V9IXNIMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/collect.vue?macro=true";
import { default as counterWa6DnsSW_jIup3Cn5ru_8HLiuJOztN2qhHSxHmS0gKUMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/counter.vue?macro=true";
import { default as filter_45config0aYthG7rTEB2bkVzyeVwbIaLnOFtihGG5SmVx2jBNygMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/config/filter-config.js?macro=true";
import { default as bindEmailpq4dcmNs07TsF_RKw6as2tI7ClbIqHrhsrUB0lWTeYEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/bindEmail.vue?macro=true";
import { default as itemwH1ZZbVoSEVhSELAMXXOacAM9gUcR9pBY_DMEY1Hr40Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/components/item.vue?macro=true";
import { default as chartselurTAsksNqLf8j8kmpghUfopwf_Y9l3z_u_cteQbhEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/statuscomponents/charts.vue?macro=true";
import { default as itemListbjiFpdxxrlfP02QghdYIkIRsG3nnrJnbPf8mtfCq66IMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/itemList.vue?macro=true";
import { default as scaleNumRheNv4__7w2pl3NTjEqAyxeY366DfVtgYYOtvCbFnBUMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/scaleNum.vue?macro=true";
import { default as commentMsgA_F2A6P0exR_IBnWMPmeh5bUWJv8aq1N_bE8U6IKXS4Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/commentMsg.vue?macro=true";
import { default as steamLoginBcX_8i2oCEyILpgnEjwu7vN1SF_ptwQLM6q3Jsln0pQMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/steamLogin.vue?macro=true";
import { default as filter_45config52o_iQ6gQwa7Pv5Jl6A05qzm_AjOISvusg9Olw9Y_hQMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/config/filter-config.js?macro=true";
import { default as changeEmailqkT8HURmFU4iDgfaBePvYhcIqjs79A0Yff9JI8GuzIIMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changeEmail.vue?macro=true";
import { default as unbindSteamfn9vn_s0Uvg6Br_P8Fcle0vGDkQZSb0nlKZbr24VB2wMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/unbindSteam.vue?macro=true";
import { default as _91itemprint_93PRBqXb5a0Ui_Sy743e8_o_JiBl5Oqe4t8ZLldWaUJs0Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/tracker/[itemprint].vue?macro=true";
import { default as indexChartltUnLNXV1Ws5UI1AlfqYoBGJwjOsnJmW5bEoIWDvLyYMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/indexChart.vue?macro=true";
import { default as changeAvatarB_iI0Q49qcE_i1zeyo7WxG8wJRSnfMs5S6gmyLDNc7cMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changeAvatar.vue?macro=true";
import { default as trendAvxufuUr_jugztW_EOfaf_Nnsh5KB3Mi532NssR5ucsMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/trend/indexconpoment/trend.vue?macro=true";
import { default as indexGEi9VGHVk1KlPiD9JcTlglWZPi2TSJxB17Vuw_v6FYwMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/post-artile/index.vue?macro=true";
import { default as indexDrawerUHZshyFjkLeF62j7tF5u6RKqB986LsKazbmSKk67MiQMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/indexDrawer.vue?macro=true";
import { default as itemcompareUi_StXueMTU_kJWyi4nbKO1v_qZJPRti_k30zYPlEUkMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/itemcompare.vue?macro=true";
import { default as klinechartssXbkywmy5C01kX_PzA_cWS9zC_1VwvJTEeG3JgJNuREMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/klinecharts.vue?macro=true";
import { default as transicationfXKkTkZtAc19_4rM_7uAt4JalwR4wp1DIIRF5d8cFlIMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/transication.vue?macro=true";
import { default as tipsj5Xn1uWBqgjDY0MPvHReKTCH5fLIEhnzqsOExzt7VsoMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/tips.vue?macro=true";
import { default as utils_CzOm5pOiqpgC2PitpUBpNDAUXH70AKSgVbl9pUA5kEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/utils.ts?macro=true";
import { default as swap_45pageTWphn_tqc642dH9Mqt_Ng8XpXZDfT4Xr149Zes_0kGkMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/swap-page.vue?macro=true";
import { default as filter_45drawerx0DFhtUdaSN9LFAUCAAVQJZy5kWpNthrqIwKETUUj4MMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/components/filter-drawer.vue?macro=true";
import { default as changeNicknameg1u2srwhprJYpt7WBRAhGfaj8rLJff3Q04XwTmpGYRwMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changeNickname.vue?macro=true";
import { default as changePasswordB6HoTl0ruuMWguY5KAVvzLyABmm8lC3Zy9IVxJKC8_oMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changePassword.vue?macro=true";
import { default as leftListYbYnC8FQPBYtQkg8wkBUyEpWjvYSR1ZYTP9Y8FT7JEgMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftList.vue?macro=true";
import { default as leftPartY1gHzNaaVTci0lEdXjX7HvnL5IegiRRlntDXLun76ioMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftPart.vue?macro=true";
import { default as leftTabsufDvhDi0FdKOVom6DLqwxSjNSENkG4LakNGugrwznA8Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftTabs.vue?macro=true";
import { default as rightHotzsCColER5bAbkH6arGUkiCjvASSsIaBH7Ce0Fr4FNFoMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightHot.vue?macro=true";
import { default as panelFjQry7b8_1KfsZNnrqY0wnJwU6Cu7qRnBdIabZPn8lkMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/panel.vue?macro=true";
import { default as dataItema3R7zowaTmmIx55uB4V3Kft0Clrhx9T9vVJytYeQfdwMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/trend/indexconpoment/dataItem.vue?macro=true";
import { default as sectionsU777O_NaWlZ8Nz3Dt459HVSeOmO1uHVdsxuA4dlW_vYMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/sections.vue?macro=true";
import { default as rightBtnsYP_1lsRnAmdq9GbZiV90dqUQImUbAsCEwqppW3vZkU4Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightBtns.vue?macro=true";
import { default as rightPartq1GngFELRsvhpZIkjXMg3YqPqlsnN_8yRzgCQoVRBScMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightPart.vue?macro=true";
import { default as update_45history8A1bPdX4Gyq8l14UlB_lONw_7C31Faw8WIq7r4LqFHUMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/update-history.vue?macro=true";
import { default as filter_45drawerReGa9BwD5I6KKiPMOqdFLj4eWP3DhyY6TyAYZLu5X0oMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/components/filter-drawer.vue?macro=true";
import { default as filter_45configGtDaAH_irTTujMYJLyOm0czb3gvx6J3KYQFqjuWfbpQMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/config/filter-config.js?macro=true";
import { default as broad_45chartYg5PD9FjBlB4zzEejZiuue_VPPC_QuyXm6noWyVsREEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/broad-chart.vue?macro=true";
import { default as hot_45sectionu2W_nTqw9iYpz8l_7GOGPpKYcXbRAgH1KLbUGX43M0gMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/hot-section.vue?macro=true";
import { default as leftSearchX9UXL8249UZOpIIZ9OcfQD32ETWES0GVwJx6OMB9ZsgMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftSearch.vue?macro=true";
import { default as new_45index_45chartXvySd39YI4e0xuNdH3qhzdCLCD_DdId__2S5iDJ_igwMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/new-index-chart.vue?macro=true";
import { default as platform_45contentUaC_emSCRQ3bbumJNQ3D5_JUbEkB7_PpHNctm_UsDCQMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/components/platform-content.vue?macro=true";
import { default as commentListAlxaSCjP7YQi1NyRWDOaxgZ3Vap14MPaeYhl1d3COLUMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/commentList.vue?macro=true";
import { default as detailTitleT6wVzZ3cBGMjl_PbuaLJDRn4ozMMct8RJ_XkOpGlBgkMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/detailTitle.vue?macro=true";
import { default as rightFooterFY62LN7Ukf3QWX4cBkPxwWIhOBPxL_5spV5zhR1oVrcMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightFooter.vue?macro=true";
import { default as item_45change_45list7Iw8wUx167CRI5npewYjcCiFFHNmPf8_TL_XpHS7K5YMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/item-change-list.vue?macro=true";
import { default as setPrice5RbvMOqrtKMuIBccP8KkB3WR2Yhlc1Icfjjxq41mLrcMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/setPrice.vue?macro=true";
import { default as filter_45drawery9wm4jkGG8X7SFELcmV1xcVTf3aY76PfzfapI7SPHy4Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/filter-drawer.vue?macro=true";
import { default as add_45followo1fly_P6HyDnITrF6psAe3ziRN_x_LfIuLzMg7Z4ccAMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/add-follow.vue?macro=true";
import { default as items_45pageYppxP3mwcF8CoPSeenxJI99ZMn20IkEhbZBBPWyTCt0Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/items-page.vue?macro=true";
import { default as set_45remarkjKMpK0rl7Ci6oxGhOuBDY4nP5GlK4ASc4mdp2MduUF0Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/set-remark.vue?macro=true";
import { default as section_45chartiiTuJJ0bQN_6Bkddbx1_l3bHPdfR__9JaXBY5FHRio0Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/section-chart.vue?macro=true";
import { default as commentInput2aj0avcWBsoka7v0ZyO4HDKYegDAv_O25l_WxMIETIYMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/commentInput.vue?macro=true";
import { default as deleteDialogkJ_unqz463W1CEZsifBcv1gnOdvVsqdyB5nqdu5u8R4Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/deleteDialog.vue?macro=true";
import { default as reportDialogCiLnwChcigQ_aU4_NU04jvNZsEPSEGfTDWGHuFS_lC8Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/reportDialog.vue?macro=true";
import { default as InventoryTop_eHHDyXK5Izmoz5XBaAbgBPu3Hhu3G8OWxv50PCGm1UMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/InventoryTop.vue?macro=true";
import { default as price_45dropdownVDqXV1pt2iDX7Hzukp1BHMrMwkRDZtSZPwaiYGPuGjEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/price-dropdown.vue?macro=true";
import { default as add_45collectF7AAtGLSUKBREHRktYHtBrT8RdkaTuZmSUv0raH9fuoMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/add-collect.vue?macro=true";
import { default as detail_45itemv1Xiu3NayIU95RTT4sIySPAY2aEIlUepJaru4Yu7XjAMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/detail-item.vue?macro=true";
import { default as item_45manageSIShq_nGsqX3A09njVyN8jh2HfFpJuHC68_kFHsxbCkMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/item-manage.vue?macro=true";
import { default as target_45tipsxdczxYMfuxOdIF6mEo6gpsv_rEvqTRM4EEK8oJphMJoMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/target-tips.vue?macro=true";
import { default as chartsk564nUEM1ITj_pVQ4eOkHB7fryVeNUZ21tg0eKkV2OEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/charts.vue?macro=true";
import { default as indexLaddersogAMvVDiyeeVY4_rYBNmmBs2q1zumVzYAG0B_sz_zp8Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/indexLadders.vue?macro=true";
import { default as InventoryInfoTAWdZkKSUnowRcB1qn3UExeLqQKlB7V9sUivaiiANqgMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/InventoryInfo.vue?macro=true";
import { default as inventoryitemYkswPzHErZ4XMQU0_sGcs_NdNNAAGw4gSGNp_HvCbiUMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/inventoryitem.vue?macro=true";
import { default as edit_45collectSHzz9rBcYy2zjjEnFBRtWY_6LmgDqPB1vZirHlXgjmQMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/edit-collect.vue?macro=true";
import { default as leftPartDetailnkJlYmxUSzNV895oikV_Pz3NOcHJ80AkbN8OibTVCNEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftPartDetail.vue?macro=true";
import { default as platformLowestPriceZ9z0dpu9tA5DTMtTG9nD5HCglwfhZNSgLFiSy0LGnEoMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/platformLowestPrice.vue?macro=true";
import { default as InventoryCSLvbRq7sg0cHkCGWxHpSneIZ5yl7A3bUnvEur3JV4_AEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/InventoryCS.vue?macro=true";
import { default as collect_45chart0kSpmYAesF00Za_RwVPtU6pcH4nsSDTnHqw2Lv4XTCwMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-chart.vue?macro=true";
import { default as follow_45dialogrMaVmhgI0QFXBCXTwkzkTK__GN0QDZmARtgNP_sldbgMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/follow-dialog.vue?macro=true";
import { default as section_45platformTSbLW93cCbezlOrQUyRgxcW4LRAzPnWG3sP63JpPHm8Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/section-platform.vue?macro=true";
import { default as chooseSkinDialog3_z9YiYD8p_6PFyJYy8m1FrFBI_samAYN1ShoNkaSp4Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/components/chooseSkinDialog.vue?macro=true";
import { default as saleListkS4mHId1XENAVO3hCa7cZB313sdUWPKSi2XLyX_rc98Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/saleList.vue?macro=true";
import { default as wearRank8H_a9wRpwNQlWk_bD6_hxZd0t8ZqfYa2La29pFmsV98Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/wearRank.vue?macro=true";
import { default as InventorySearchp9x9_j4p9LqzqEcseg3LiPQC0MgC3zKnB4ky58DvpogMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/InventorySearch.vue?macro=true";
import { default as sellNums_45dropdownuugCRDUMHYsNkNtbNCQk5NhK_A1cuym38cfj9agxKT0Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/sellNums-dropdown.vue?macro=true";
import { default as collect_45chartsFITr6GGmKZrnLPgwDYsgGNPqu_h8fJoKDTsIkUO0Fa4Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-charts.vue?macro=true";
import { default as collect_45detailsaUnZfBfxCU3TkKqOZJmHKC8GRy1bdkyMzByV59z71sMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-detail.vue?macro=true";
import { default as collect_45managehR0dQLm_FcM9gD3dv1r1ae0JPMcyIswv8YH0I_q2CUoMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-manage.vue?macro=true";
import { default as compare_45followu9gdUCnosBe6_i6M7cIyIHeGcXGxWcTDqoFpDLuA9rkMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/compare-follow.vue?macro=true";
import { default as create_45collectvKwuVl38SOfy8D57cMPYwvTQlKcOKR7AvhXHDUfsdd8Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/create-collect.vue?macro=true";
import { default as delete_45collectalz4_jAuccx5g9F4qJSCGSh1jlk7LZiPwct1fPvysgcMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/delete-collect.vue?macro=true";
import { default as filter_45contentxF4IViaHCu6YkNWf8XuJH0Y2FPrKaIRFSTavurQMU4MMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/filter-content.vue?macro=true";
import { default as inventory_45pagesgplKZBl0gSocEZ7T_9G3jMnZLqySb7YiukNEO2DHNkMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/inventory-page.vue?macro=true";
import { default as mkt_45valueViewerFe_ap991MOLROdz_Ske_MYdRIn9EF2_mG8tVhkWT4JkMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/components/mkt-valueViewer.vue?macro=true";
import { default as trackerItem2_cvZ8wSq6deDOPZYNnt9xer6mf_sRb8_BJZbY22v2AMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/tracker/components/trackerItem.vue?macro=true";
import { default as set_45targetPriceUL5iflHKPy7Ft09US8NdFoIvkVx4A2Jan0dCcQopdGEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/set-targetPrice.vue?macro=true";
import { default as unlogin_45contentxa33qrS9lwCqiUBZ9oJ1mw8E8V1IQ_QCIVsrjVnE_jsMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/unlogin-content.vue?macro=true";
import { default as onsaleListsnhvSjH7SMX7GjHE51DRwFrK5MYqswX1ac7Qh10cw24Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/onsaleList.vue?macro=true";
import { default as selectTopicDialogyuPCv8fujoXVNMIyVb5CDZAnQNJDGq_oJJBjdaQn1jUMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/selectTopicDialog.vue?macro=true";
import { default as indexWerRAcTXNAMjpi3wFQt623_FFlwnZZciN4_fJqnb_xYMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/index.vue?macro=true";
import { default as ladders_45lowestPriceWDn819qsumkFvrlkjCuQnv9wql28NwNnvRZUOLSCsUYMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/ladders-lowestPrice.vue?macro=true";
import { default as detail_45item_45listjdjY_GHRpWqMScvnKRS4u3Z5dRq45CQLXkyxnyr4cowMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/detail-item-list.vue?macro=true";
import { default as itemCollect_45listyh6yVHG6HwE9vRcudIfEVxqDS0N19FzAIPZyQbvFeJIMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/itemCollect-list.vue?macro=true";
import { default as chooseStickerDialogGHky1bof9_ZUYDvXGCTVIkcUQtCRSH_mcDzP0dFIEY4Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/components/chooseStickerDialog.vue?macro=true";
import { default as setPriceHistoryxV2RZuNHH0TeyIy5JoC7yUqG0r_G__c22354Ng0_USYMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/setPriceHistory.vue?macro=true";
import { default as SevenDaysInventorypqphjZd89pDkm9972NIWw25mxS9_GnFTv8qM0wUOLFYMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/SevenDaysInventory.vue?macro=true";
import { default as addFilterConditionR_q9gzBZI7zKI8S_09xapC1NnH_W00bPqIq0CmNgT08Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/components/addFilterCondition.vue?macro=true";
import { default as item_45trackerSheikrAMoioJ2wzu3aVjJSMTBK6_qVxvbNNlGe2V8NkMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/item-tracker.vue?macro=true";
import { default as transication3X1AcBJ7mHmlwNTpyvCjOSHmRXDLvC02RsDIsoC3PDUMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/transication.vue?macro=true";
import { default as inventoryChanges9OsmPLfoIKYxAS54JssRCtuQ3CCXz3GgekH9Kr2mMMgMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/inventoryChanges.vue?macro=true";
import { default as ladder_45center_45content0DJ2nN3xgTaPuTwA7vlmugnR45sZfPnnkyCZUAlP8D0Meta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/ladder-center-content.vue?macro=true";
import { default as swap_45platform_45comparewzvQOuNJ95OV1pGvW5uzNlIi_D1SYvl8jJUsPMdZdhEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/swap-platform-compare.vue?macro=true";
import { default as transication_45dropdown_N3JrSOQsvE7fDV9wFZZJ2SS6EEqXxXEUC5kaIpAgfEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/transication-dropdown.vue?macro=true";
import { default as detail_45target_45tips_Xc1z8F4fLo1xUaLTOTHNLOyAWS3zjVdoIocmlXG1kEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/detail-target-tips.vue?macro=true";
import { default as detail_45headeriS6N8CyoKxyu9K6CwBQVV17QQwHVlNd0zT4zLv75NXAMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/detail-header.vue?macro=true";
import { default as price_45contentvHTNOUX7ZjWzNC6RmBkWrjyNG5uG3NhTbHWljius4eAMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/price-content.vue?macro=true";
import { default as historicalPositionsXkEQoxMrVmdpznSxbnVwS_wD1M9TIryj3SMILCuIw6QMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/historicalPositions.vue?macro=true";
import { default as transactionDetailtxVWeHv0whs0ck_aHsK4374_2boWZi3XVKFSPXOnWKQMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/transactionDetail.vue?macro=true";
import { default as indexLadder_45collectListOou2dEmVvcxAnPhavlUW9Rpy_wN96SbBL6UjOUzg9VEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/indexLadder-collectList.vue?macro=true";
import { default as indexLadder_45hangingListxJPmWZMacQdry3yDcy7pJ9gyXIljaFYctWYxqZ1ia4AMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/indexLadder-hangingList.vue?macro=true";
import { default as cs2InventoryRw_PwG7jJZClOO260EbMn0m8WcFcKXj8_qV9_kWr1_oMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/cs2Inventory.vue?macro=true";
import { default as SevenDaysInventoryDetailH1opcXwebFsI5oTP9Lm15WE_VI_0NJhTkq9bobTzP7wMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/SevenDaysInventoryDetail.vue?macro=true";
import { default as inventory_45collect_45manage4N0xfmkex13JTPzuY3hx8HK7pUL8mdKndoWOyKTb7KsMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/inventory-collect-manage.vue?macro=true";
import { default as inventoryChangesz8DKp0LukzC9BBsZbm30ap19HzKVCcTQ6Puksj0JmQEMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/inventoryChanges.vue?macro=true";
import { default as historicalPositions5YCnu9UZgDVwcbE2lgGb7ySE3F7aH_0ArDqk2fty5_kMeta } from "/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/historicalPositions.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/en",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/index.vue")
  },
  {
    name: "index___zh___default",
    path: "/",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/index.vue")
  },
  {
    name: "status___en",
    path: "/en/status",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/status.vue")
  },
  {
    name: "status___zh___default",
    path: "/status",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/status.vue")
  },
  {
    name: "status___zh",
    path: "/zh/status",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/status.vue")
  },
  {
    name: "update___en",
    path: "/en/update",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/update.vue")
  },
  {
    name: "update___zh___default",
    path: "/update",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/update.vue")
  },
  {
    name: "update___zh",
    path: "/zh/update",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/update.vue")
  },
  {
    name: "changes___en",
    path: "/en/changes",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/changes.vue")
  },
  {
    name: "changes___zh___default",
    path: "/changes",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/changes.vue")
  },
  {
    name: "changes___zh",
    path: "/zh/changes",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/changes.vue")
  },
  {
    name: "error-404___en",
    path: "/en/error/404",
    meta: _404T0QBajQrJqUcCzNeMkUypaAxutI12gCtrnb4LyLPAN4Meta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/error/404.vue")
  },
  {
    name: "error-404___zh___default",
    path: "/error/404",
    meta: _404T0QBajQrJqUcCzNeMkUypaAxutI12gCtrnb4LyLPAN4Meta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/error/404.vue")
  },
  {
    name: "error-404___zh",
    path: "/zh/error/404",
    meta: _404T0QBajQrJqUcCzNeMkUypaAxutI12gCtrnb4LyLPAN4Meta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/error/404.vue")
  },
  {
    name: "error-500___en",
    path: "/en/error/500",
    meta: _500q6QBDO_Dydra0zi9eUdveJDhT8ag48HdnXknsBQB834Meta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/error/500.vue")
  },
  {
    name: "error-500___zh___default",
    path: "/error/500",
    meta: _500q6QBDO_Dydra0zi9eUdveJDhT8ag48HdnXknsBQB834Meta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/error/500.vue")
  },
  {
    name: "error-500___zh",
    path: "/zh/error/500",
    meta: _500q6QBDO_Dydra0zi9eUdveJDhT8ag48HdnXknsBQB834Meta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/error/500.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/faq/index.vue")
  },
  {
    name: "faq___zh___default",
    path: "/faq",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/faq/index.vue")
  },
  {
    name: "faq___zh",
    path: "/zh/faq",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/faq/index.vue")
  },
  {
    name: "mkt___en",
    path: "/en/mkt",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/index.vue")
  },
  {
    name: "mkt___zh___default",
    path: "/mkt",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/index.vue")
  },
  {
    name: "mkt___zh",
    path: "/zh/mkt",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/index.vue")
  },
  {
    name: "case___en",
    path: "/en/case",
    meta: indexVhgZKAGPL6F3zfjJrvP7atVDOjDorAALwL4efmRwydcMeta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/case/index.vue")
  },
  {
    name: "case___zh___default",
    path: "/case",
    meta: indexVhgZKAGPL6F3zfjJrvP7atVDOjDorAALwL4efmRwydcMeta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/case/index.vue")
  },
  {
    name: "case___zh",
    path: "/zh/case",
    meta: indexVhgZKAGPL6F3zfjJrvP7atVDOjDorAALwL4efmRwydcMeta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/case/index.vue")
  },
  {
    name: "my-setting___en",
    path: "/en/my/setting",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/setting.vue")
  },
  {
    name: "my-setting___zh___default",
    path: "/my/setting",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/setting.vue")
  },
  {
    name: "my-setting___zh",
    path: "/zh/my/setting",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/setting.vue")
  },
  {
    name: "items___en",
    path: "/en/items",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/index.vue")
  },
  {
    name: "items___zh___default",
    path: "/items",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/index.vue")
  },
  {
    name: "items___zh",
    path: "/zh/items",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/index.vue")
  },
  {
    name: "login-steam___en",
    path: "/en/login/steam",
    meta: steammj3KLOvMd22QEFAZpL4v_qrtHSqkjF5E0ifycBgHA4sMeta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/login/steam.vue")
  },
  {
    name: "login-steam___zh___default",
    path: "/login/steam",
    meta: steammj3KLOvMd22QEFAZpL4v_qrtHSqkjF5E0ifycBgHA4sMeta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/login/steam.vue")
  },
  {
    name: "login-steam___zh",
    path: "/zh/login/steam",
    meta: steammj3KLOvMd22QEFAZpL4v_qrtHSqkjF5E0ifycBgHA4sMeta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/login/steam.vue")
  },
  {
    name: "trend___en",
    path: "/en/trend",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/trend/index.vue")
  },
  {
    name: "trend___zh___default",
    path: "/trend",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/trend/index.vue")
  },
  {
    name: "trend___zh",
    path: "/zh/trend",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/trend/index.vue")
  },
  {
    name: "inventory-my___en",
    path: "/en/inventory/my",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/my.vue")
  },
  {
    name: "inventory-my___zh___default",
    path: "/inventory/my",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/my.vue")
  },
  {
    name: "inventory-my___zh",
    path: "/zh/inventory/my",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/my.vue")
  },
  {
    name: "terms-type___en",
    path: "/en/terms/:type()",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/terms/[type].vue")
  },
  {
    name: "terms-type___zh___default",
    path: "/terms/:type()",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/terms/[type].vue")
  },
  {
    name: "terms-type___zh",
    path: "/zh/terms/:type()",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/terms/[type].vue")
  },
  {
    name: "hanging___en",
    path: "/en/hanging",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/hanging/index.vue")
  },
  {
    name: "hanging___zh___default",
    path: "/hanging",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/hanging/index.vue")
  },
  {
    name: "hanging___zh",
    path: "/zh/hanging",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/hanging/index.vue")
  },
  {
    name: "ladders___en",
    path: "/en/ladders",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/index.vue")
  },
  {
    name: "ladders___zh___default",
    path: "/ladders",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/index.vue")
  },
  {
    name: "ladders___zh",
    path: "/zh/ladders",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/index.vue")
  },
  {
    name: "my-third-bind___en",
    path: "/en/my/third-bind",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/third-bind.vue")
  },
  {
    name: "my-third-bind___zh___default",
    path: "/my/third-bind",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/third-bind.vue")
  },
  {
    name: "my-third-bind___zh",
    path: "/zh/my/third-bind",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/third-bind.vue")
  },
  {
    name: "section___en",
    path: "/en/section",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/index.vue")
  },
  {
    name: "section___zh___default",
    path: "/section",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/index.vue")
  },
  {
    name: "section___zh",
    path: "/zh/section",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/index.vue")
  },
  {
    name: "skindiy___en",
    path: "/en/skindiy",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/index.vue")
  },
  {
    name: "skindiy___zh___default",
    path: "/skindiy",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/index.vue")
  },
  {
    name: "skindiy___zh",
    path: "/zh/skindiy",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/index.vue")
  },
  {
    name: "inventory-const___en",
    path: "/en/inventory/const",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/const.ts")
  },
  {
    name: "inventory-const___zh___default",
    path: "/inventory/const",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/const.ts")
  },
  {
    name: "inventory-const___zh",
    path: "/zh/inventory/const",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/const.ts")
  },
  {
    name: "community___en",
    path: "/en/community",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/index.vue")
  },
  {
    name: "community___zh___default",
    path: "/community",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/index.vue")
  },
  {
    name: "community___zh",
    path: "/zh/community",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/index.vue")
  },
  {
    name: "inventory___en",
    path: "/en/inventory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___zh___default",
    path: "/inventory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___zh",
    path: "/zh/inventory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/index.vue")
  },
  {
    name: "login-bindSteam___en",
    path: "/en/login/bindSteam",
    meta: bindSteam7Z0bSochdx18IxQPuih0WVsWGsBHJii2Cav_xYvs6j4Meta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/login/bindSteam.vue")
  },
  {
    name: "login-bindSteam___zh___default",
    path: "/login/bindSteam",
    meta: bindSteam7Z0bSochdx18IxQPuih0WVsWGsBHJii2Cav_xYvs6j4Meta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/login/bindSteam.vue")
  },
  {
    name: "login-bindSteam___zh",
    path: "/zh/login/bindSteam",
    meta: bindSteam7Z0bSochdx18IxQPuih0WVsWGsBHJii2Cav_xYvs6j4Meta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/login/bindSteam.vue")
  },
  {
    name: "selection___en",
    path: "/en/selection",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/index.vue")
  },
  {
    name: "selection___zh___default",
    path: "/selection",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/index.vue")
  },
  {
    name: "selection___zh",
    path: "/zh/selection",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/index.vue")
  },
  {
    name: "my-collect___en",
    path: "/en/my/collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/index.vue")
  },
  {
    name: "my-collect___zh___default",
    path: "/my/collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/index.vue")
  },
  {
    name: "my-collect___zh",
    path: "/zh/my/collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/index.vue")
  },
  {
    name: "my-components-api___en",
    path: "/en/my/components/api",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/api.vue")
  },
  {
    name: "my-components-api___zh___default",
    path: "/my/components/api",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/api.vue")
  },
  {
    name: "my-components-api___zh",
    path: "/zh/my/components/api",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/api.vue")
  },
  {
    name: "my-components-post___en",
    path: "/en/my/components/post",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/post.vue")
  },
  {
    name: "my-components-post___zh___default",
    path: "/my/components/post",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/post.vue")
  },
  {
    name: "my-components-post___zh",
    path: "/zh/my/components/post",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/post.vue")
  },
  {
    name: "selection-favorite___en",
    path: "/en/selection/favorite",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/favorite.vue")
  },
  {
    name: "selection-favorite___zh___default",
    path: "/selection/favorite",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/favorite.vue")
  },
  {
    name: "selection-favorite___zh",
    path: "/zh/selection/favorite",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/favorite.vue")
  },
  {
    name: "index-xinyingbackup___en",
    path: "/en/index-xinyingbackup",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/index-xinyingbackup.vue")
  },
  {
    name: "index-xinyingbackup___zh___default",
    path: "/index-xinyingbackup",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/index-xinyingbackup.vue")
  },
  {
    name: "index-xinyingbackup___zh",
    path: "/zh/index-xinyingbackup",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/index-xinyingbackup.vue")
  },
  {
    name: "inventory-steamId___en",
    path: "/en/inventory/:steamId()",
    meta: _91steamId_93znHB9Ccad9Vq3tbmT0mRdcB7nRRYZvSv8R9SP5pako4Meta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/[steamId].vue")
  },
  {
    name: "inventory-steamId___zh___default",
    path: "/inventory/:steamId()",
    meta: _91steamId_93znHB9Ccad9Vq3tbmT0mRdcB7nRRYZvSv8R9SP5pako4Meta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/[steamId].vue")
  },
  {
    name: "inventory-steamId___zh",
    path: "/zh/inventory/:steamId()",
    meta: _91steamId_93znHB9Ccad9Vq3tbmT0mRdcB7nRRYZvSv8R9SP5pako4Meta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/[steamId].vue")
  },
  {
    name: "mkt-components-item___en",
    path: "/en/mkt/components/item",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/components/item.vue")
  },
  {
    name: "mkt-components-item___zh___default",
    path: "/mkt/components/item",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/components/item.vue")
  },
  {
    name: "mkt-components-item___zh",
    path: "/zh/mkt/components/item",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/components/item.vue")
  },
  {
    name: "my-components-steam___en",
    path: "/en/my/components/steam",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/steam.vue")
  },
  {
    name: "my-components-steam___zh___default",
    path: "/my/components/steam",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/steam.vue")
  },
  {
    name: "my-components-steam___zh",
    path: "/zh/my/components/steam",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/steam.vue")
  },
  {
    name: "game-tracker___en",
    path: "/en/:game()/tracker",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/tracker/index.vue")
  },
  {
    name: "game-tracker___zh___default",
    path: "/:game()/tracker",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/tracker/index.vue")
  },
  {
    name: "game-tracker___zh",
    path: "/zh/:game()/tracker",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/tracker/index.vue")
  },
  {
    name: "my-components-alipay___en",
    path: "/en/my/components/alipay",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/alipay.vue")
  },
  {
    name: "my-components-alipay___zh___default",
    path: "/my/components/alipay",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/alipay.vue")
  },
  {
    name: "my-components-alipay___zh",
    path: "/zh/my/components/alipay",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/alipay.vue")
  },
  {
    name: "my-components-sysMsg___en",
    path: "/en/my/components/sysMsg",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/sysMsg.vue")
  },
  {
    name: "my-components-sysMsg___zh___default",
    path: "/my/components/sysMsg",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/sysMsg.vue")
  },
  {
    name: "my-components-sysMsg___zh",
    path: "/zh/my/components/sysMsg",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/sysMsg.vue")
  },
  {
    name: "items-components-item___en",
    path: "/en/items/components/item",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/components/item.vue")
  },
  {
    name: "items-components-item___zh___default",
    path: "/items/components/item",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/components/item.vue")
  },
  {
    name: "items-components-item___zh",
    path: "/zh/items/components/item",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/components/item.vue")
  },
  {
    name: "my-components-likeMsg___en",
    path: "/en/my/components/likeMsg",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/likeMsg.vue")
  },
  {
    name: "my-components-likeMsg___zh___default",
    path: "/my/components/likeMsg",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/likeMsg.vue")
  },
  {
    name: "my-components-likeMsg___zh",
    path: "/zh/my/components/likeMsg",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/likeMsg.vue")
  },
  {
    name: "my-components-message___en",
    path: "/en/my/components/message",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/message.vue")
  },
  {
    name: "my-components-message___zh___default",
    path: "/my/components/message",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/message.vue")
  },
  {
    name: "my-components-message___zh",
    path: "/zh/my/components/message",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/message.vue")
  },
  {
    name: "my-components-sideBar___en",
    path: "/en/my/components/sideBar",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/sideBar.vue")
  },
  {
    name: "my-components-sideBar___zh___default",
    path: "/my/components/sideBar",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/sideBar.vue")
  },
  {
    name: "my-components-sideBar___zh",
    path: "/zh/my/components/sideBar",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/sideBar.vue")
  },
  {
    name: "community-detail___en",
    path: "/en/community/detail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/detail/index.vue")
  },
  {
    name: "community-detail___zh___default",
    path: "/community/detail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/detail/index.vue")
  },
  {
    name: "community-detail___zh",
    path: "/zh/community/detail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/detail/index.vue")
  },
  {
    name: "indexcomponents-online___en",
    path: "/en/indexcomponents/online",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/online.vue")
  },
  {
    name: "indexcomponents-online___zh___default",
    path: "/indexcomponents/online",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/online.vue")
  },
  {
    name: "indexcomponents-online___zh",
    path: "/zh/indexcomponents/online",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/online.vue")
  },
  {
    name: "my-components-postItem___en",
    path: "/en/my/components/postItem",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/postItem.vue")
  },
  {
    name: "my-components-postItem___zh___default",
    path: "/my/components/postItem",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/postItem.vue")
  },
  {
    name: "my-components-postItem___zh",
    path: "/zh/my/components/postItem",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/postItem.vue")
  },
  {
    name: "game-marketHashName___en",
    path: "/en/:game()/:marketHashName()",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/[marketHashName].vue")
  },
  {
    name: "game-marketHashName___zh___default",
    path: "/:game()/:marketHashName()",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/[marketHashName].vue")
  },
  {
    name: "game-marketHashName___zh",
    path: "/zh/:game()/:marketHashName()",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/[marketHashName].vue")
  },
  {
    name: "indexcomponents-collect___en",
    path: "/en/indexcomponents/collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/collect.vue")
  },
  {
    name: "indexcomponents-collect___zh___default",
    path: "/indexcomponents/collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/collect.vue")
  },
  {
    name: "indexcomponents-collect___zh",
    path: "/zh/indexcomponents/collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/collect.vue")
  },
  {
    name: "indexcomponents-counter___en",
    path: "/en/indexcomponents/counter",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/counter.vue")
  },
  {
    name: "indexcomponents-counter___zh___default",
    path: "/indexcomponents/counter",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/counter.vue")
  },
  {
    name: "indexcomponents-counter___zh",
    path: "/zh/indexcomponents/counter",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/counter.vue")
  },
  {
    name: "mkt-config-filter-config___en",
    path: "/en/mkt/config/filter-config",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/config/filter-config.js")
  },
  {
    name: "mkt-config-filter-config___zh___default",
    path: "/mkt/config/filter-config",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/config/filter-config.js")
  },
  {
    name: "mkt-config-filter-config___zh",
    path: "/zh/mkt/config/filter-config",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/config/filter-config.js")
  },
  {
    name: "my-components-bindEmail___en",
    path: "/en/my/components/bindEmail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/bindEmail.vue")
  },
  {
    name: "my-components-bindEmail___zh___default",
    path: "/my/components/bindEmail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/bindEmail.vue")
  },
  {
    name: "my-components-bindEmail___zh",
    path: "/zh/my/components/bindEmail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/bindEmail.vue")
  },
  {
    name: "skindiy-components-item___en",
    path: "/en/skindiy/components/item",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/components/item.vue")
  },
  {
    name: "skindiy-components-item___zh___default",
    path: "/skindiy/components/item",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/components/item.vue")
  },
  {
    name: "skindiy-components-item___zh",
    path: "/zh/skindiy/components/item",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/components/item.vue")
  },
  {
    name: "statuscomponents-charts___en",
    path: "/en/statuscomponents/charts",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/statuscomponents/charts.vue")
  },
  {
    name: "statuscomponents-charts___zh___default",
    path: "/statuscomponents/charts",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/statuscomponents/charts.vue")
  },
  {
    name: "statuscomponents-charts___zh",
    path: "/zh/statuscomponents/charts",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/statuscomponents/charts.vue")
  },
  {
    name: "indexcomponents-itemList___en",
    path: "/en/indexcomponents/itemList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/itemList.vue")
  },
  {
    name: "indexcomponents-itemList___zh___default",
    path: "/indexcomponents/itemList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/itemList.vue")
  },
  {
    name: "indexcomponents-itemList___zh",
    path: "/zh/indexcomponents/itemList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/itemList.vue")
  },
  {
    name: "indexcomponents-scaleNum___en",
    path: "/en/indexcomponents/scaleNum",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/scaleNum.vue")
  },
  {
    name: "indexcomponents-scaleNum___zh___default",
    path: "/indexcomponents/scaleNum",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/scaleNum.vue")
  },
  {
    name: "indexcomponents-scaleNum___zh",
    path: "/zh/indexcomponents/scaleNum",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/scaleNum.vue")
  },
  {
    name: "my-components-commentMsg___en",
    path: "/en/my/components/commentMsg",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/commentMsg.vue")
  },
  {
    name: "my-components-commentMsg___zh___default",
    path: "/my/components/commentMsg",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/commentMsg.vue")
  },
  {
    name: "my-components-commentMsg___zh",
    path: "/zh/my/components/commentMsg",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/commentMsg.vue")
  },
  {
    name: "my-components-steamLogin___en",
    path: "/en/my/components/steamLogin",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/steamLogin.vue")
  },
  {
    name: "my-components-steamLogin___zh___default",
    path: "/my/components/steamLogin",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/steamLogin.vue")
  },
  {
    name: "my-components-steamLogin___zh",
    path: "/zh/my/components/steamLogin",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/steamLogin.vue")
  },
  {
    name: "items-config-filter-config___en",
    path: "/en/items/config/filter-config",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/config/filter-config.js")
  },
  {
    name: "items-config-filter-config___zh___default",
    path: "/items/config/filter-config",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/config/filter-config.js")
  },
  {
    name: "items-config-filter-config___zh",
    path: "/zh/items/config/filter-config",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/config/filter-config.js")
  },
  {
    name: "my-components-changeEmail___en",
    path: "/en/my/components/changeEmail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changeEmail.vue")
  },
  {
    name: "my-components-changeEmail___zh___default",
    path: "/my/components/changeEmail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changeEmail.vue")
  },
  {
    name: "my-components-changeEmail___zh",
    path: "/zh/my/components/changeEmail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changeEmail.vue")
  },
  {
    name: "my-components-unbindSteam___en",
    path: "/en/my/components/unbindSteam",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/unbindSteam.vue")
  },
  {
    name: "my-components-unbindSteam___zh___default",
    path: "/my/components/unbindSteam",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/unbindSteam.vue")
  },
  {
    name: "my-components-unbindSteam___zh",
    path: "/zh/my/components/unbindSteam",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/unbindSteam.vue")
  },
  {
    name: "game-tracker-itemprint___en",
    path: "/en/:game()/tracker/:itemprint()",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/tracker/[itemprint].vue")
  },
  {
    name: "game-tracker-itemprint___zh___default",
    path: "/:game()/tracker/:itemprint()",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/tracker/[itemprint].vue")
  },
  {
    name: "game-tracker-itemprint___zh",
    path: "/zh/:game()/tracker/:itemprint()",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/tracker/[itemprint].vue")
  },
  {
    name: "indexcomponents-indexChart___en",
    path: "/en/indexcomponents/indexChart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/indexChart.vue")
  },
  {
    name: "indexcomponents-indexChart___zh___default",
    path: "/indexcomponents/indexChart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/indexChart.vue")
  },
  {
    name: "indexcomponents-indexChart___zh",
    path: "/zh/indexcomponents/indexChart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/indexChart.vue")
  },
  {
    name: "my-components-changeAvatar___en",
    path: "/en/my/components/changeAvatar",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changeAvatar.vue")
  },
  {
    name: "my-components-changeAvatar___zh___default",
    path: "/my/components/changeAvatar",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changeAvatar.vue")
  },
  {
    name: "my-components-changeAvatar___zh",
    path: "/zh/my/components/changeAvatar",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changeAvatar.vue")
  },
  {
    name: "trend-indexconpoment-trend___en",
    path: "/en/trend/indexconpoment/trend",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/trend/indexconpoment/trend.vue")
  },
  {
    name: "trend-indexconpoment-trend___zh___default",
    path: "/trend/indexconpoment/trend",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/trend/indexconpoment/trend.vue")
  },
  {
    name: "trend-indexconpoment-trend___zh",
    path: "/zh/trend/indexconpoment/trend",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/trend/indexconpoment/trend.vue")
  },
  {
    name: "community-post-artile___en",
    path: "/en/community/post-artile",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/post-artile/index.vue")
  },
  {
    name: "community-post-artile___zh___default",
    path: "/community/post-artile",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/post-artile/index.vue")
  },
  {
    name: "community-post-artile___zh",
    path: "/zh/community/post-artile",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/post-artile/index.vue")
  },
  {
    name: "indexcomponents-indexDrawer___en",
    path: "/en/indexcomponents/indexDrawer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/indexDrawer.vue")
  },
  {
    name: "indexcomponents-indexDrawer___zh___default",
    path: "/indexcomponents/indexDrawer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/indexDrawer.vue")
  },
  {
    name: "indexcomponents-indexDrawer___zh",
    path: "/zh/indexcomponents/indexDrawer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/indexDrawer.vue")
  },
  {
    name: "indexcomponents-itemcompare___en",
    path: "/en/indexcomponents/itemcompare",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/itemcompare.vue")
  },
  {
    name: "indexcomponents-itemcompare___zh___default",
    path: "/indexcomponents/itemcompare",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/itemcompare.vue")
  },
  {
    name: "indexcomponents-itemcompare___zh",
    path: "/zh/indexcomponents/itemcompare",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/itemcompare.vue")
  },
  {
    name: "indexcomponents-klinecharts___en",
    path: "/en/indexcomponents/klinecharts",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/klinecharts.vue")
  },
  {
    name: "indexcomponents-klinecharts___zh___default",
    path: "/indexcomponents/klinecharts",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/klinecharts.vue")
  },
  {
    name: "indexcomponents-klinecharts___zh",
    path: "/zh/indexcomponents/klinecharts",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/klinecharts.vue")
  },
  {
    name: "indexcomponents-transication___en",
    path: "/en/indexcomponents/transication",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/transication.vue")
  },
  {
    name: "indexcomponents-transication___zh___default",
    path: "/indexcomponents/transication",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/transication.vue")
  },
  {
    name: "indexcomponents-transication___zh",
    path: "/zh/indexcomponents/transication",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/transication.vue")
  },
  {
    name: "inventory-components-my-tips___en",
    path: "/en/inventory/components/my/tips",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/tips.vue")
  },
  {
    name: "inventory-components-my-tips___zh___default",
    path: "/inventory/components/my/tips",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/tips.vue")
  },
  {
    name: "inventory-components-my-tips___zh",
    path: "/zh/inventory/components/my/tips",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/tips.vue")
  },
  {
    name: "inventory-components-my-utils___en",
    path: "/en/inventory/components/my/utils",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/utils.ts")
  },
  {
    name: "inventory-components-my-utils___zh___default",
    path: "/inventory/components/my/utils",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/utils.ts")
  },
  {
    name: "inventory-components-my-utils___zh",
    path: "/zh/inventory/components/my/utils",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/utils.ts")
  },
  {
    name: "ladders-components-swap-page___en",
    path: "/en/ladders/components/swap-page",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/swap-page.vue")
  },
  {
    name: "ladders-components-swap-page___zh___default",
    path: "/ladders/components/swap-page",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/swap-page.vue")
  },
  {
    name: "ladders-components-swap-page___zh",
    path: "/zh/ladders/components/swap-page",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/swap-page.vue")
  },
  {
    name: "mkt-components-filter-drawer___en",
    path: "/en/mkt/components/filter-drawer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/components/filter-drawer.vue")
  },
  {
    name: "mkt-components-filter-drawer___zh___default",
    path: "/mkt/components/filter-drawer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/components/filter-drawer.vue")
  },
  {
    name: "mkt-components-filter-drawer___zh",
    path: "/zh/mkt/components/filter-drawer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/components/filter-drawer.vue")
  },
  {
    name: "my-components-changeNickname___en",
    path: "/en/my/components/changeNickname",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changeNickname.vue")
  },
  {
    name: "my-components-changeNickname___zh___default",
    path: "/my/components/changeNickname",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changeNickname.vue")
  },
  {
    name: "my-components-changeNickname___zh",
    path: "/zh/my/components/changeNickname",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changeNickname.vue")
  },
  {
    name: "my-components-changePassword___en",
    path: "/en/my/components/changePassword",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changePassword.vue")
  },
  {
    name: "my-components-changePassword___zh___default",
    path: "/my/components/changePassword",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changePassword.vue")
  },
  {
    name: "my-components-changePassword___zh",
    path: "/zh/my/components/changePassword",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/components/changePassword.vue")
  },
  {
    name: "community-components-leftList___en",
    path: "/en/community/components/leftList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftList.vue")
  },
  {
    name: "community-components-leftList___zh___default",
    path: "/community/components/leftList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftList.vue")
  },
  {
    name: "community-components-leftList___zh",
    path: "/zh/community/components/leftList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftList.vue")
  },
  {
    name: "community-components-leftPart___en",
    path: "/en/community/components/leftPart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftPart.vue")
  },
  {
    name: "community-components-leftPart___zh___default",
    path: "/community/components/leftPart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftPart.vue")
  },
  {
    name: "community-components-leftPart___zh",
    path: "/zh/community/components/leftPart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftPart.vue")
  },
  {
    name: "community-components-leftTabs___en",
    path: "/en/community/components/leftTabs",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftTabs.vue")
  },
  {
    name: "community-components-leftTabs___zh___default",
    path: "/community/components/leftTabs",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftTabs.vue")
  },
  {
    name: "community-components-leftTabs___zh",
    path: "/zh/community/components/leftTabs",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftTabs.vue")
  },
  {
    name: "community-components-rightHot___en",
    path: "/en/community/components/rightHot",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightHot.vue")
  },
  {
    name: "community-components-rightHot___zh___default",
    path: "/community/components/rightHot",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightHot.vue")
  },
  {
    name: "community-components-rightHot___zh",
    path: "/zh/community/components/rightHot",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightHot.vue")
  },
  {
    name: "inventory-components-my-panel___en",
    path: "/en/inventory/components/my/panel",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/panel.vue")
  },
  {
    name: "inventory-components-my-panel___zh___default",
    path: "/inventory/components/my/panel",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/panel.vue")
  },
  {
    name: "inventory-components-my-panel___zh",
    path: "/zh/inventory/components/my/panel",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/panel.vue")
  },
  {
    name: "trend-indexconpoment-dataItem___en",
    path: "/en/trend/indexconpoment/dataItem",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/trend/indexconpoment/dataItem.vue")
  },
  {
    name: "trend-indexconpoment-dataItem___zh___default",
    path: "/trend/indexconpoment/dataItem",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/trend/indexconpoment/dataItem.vue")
  },
  {
    name: "trend-indexconpoment-dataItem___zh",
    path: "/zh/trend/indexconpoment/dataItem",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/trend/indexconpoment/dataItem.vue")
  },
  {
    name: "allnewIndexComponents-sections___en",
    path: "/en/allnewIndexComponents/sections",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/sections.vue")
  },
  {
    name: "allnewIndexComponents-sections___zh___default",
    path: "/allnewIndexComponents/sections",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/sections.vue")
  },
  {
    name: "allnewIndexComponents-sections___zh",
    path: "/zh/allnewIndexComponents/sections",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/sections.vue")
  },
  {
    name: "community-components-rightBtns___en",
    path: "/en/community/components/rightBtns",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightBtns.vue")
  },
  {
    name: "community-components-rightBtns___zh___default",
    path: "/community/components/rightBtns",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightBtns.vue")
  },
  {
    name: "community-components-rightBtns___zh",
    path: "/zh/community/components/rightBtns",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightBtns.vue")
  },
  {
    name: "community-components-rightPart___en",
    path: "/en/community/components/rightPart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightPart.vue")
  },
  {
    name: "community-components-rightPart___zh___default",
    path: "/community/components/rightPart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightPart.vue")
  },
  {
    name: "community-components-rightPart___zh",
    path: "/zh/community/components/rightPart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightPart.vue")
  },
  {
    name: "indexcomponents-update-history___en",
    path: "/en/indexcomponents/update-history",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/update-history.vue")
  },
  {
    name: "indexcomponents-update-history___zh___default",
    path: "/indexcomponents/update-history",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/update-history.vue")
  },
  {
    name: "indexcomponents-update-history___zh",
    path: "/zh/indexcomponents/update-history",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/update-history.vue")
  },
  {
    name: "items-components-filter-drawer___en",
    path: "/en/items/components/filter-drawer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/components/filter-drawer.vue")
  },
  {
    name: "items-components-filter-drawer___zh___default",
    path: "/items/components/filter-drawer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/components/filter-drawer.vue")
  },
  {
    name: "items-components-filter-drawer___zh",
    path: "/zh/items/components/filter-drawer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/items/components/filter-drawer.vue")
  },
  {
    name: "my-collect-config-filter-config___en",
    path: "/en/my/collect/config/filter-config",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/config/filter-config.js")
  },
  {
    name: "my-collect-config-filter-config___zh___default",
    path: "/my/collect/config/filter-config",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/config/filter-config.js")
  },
  {
    name: "my-collect-config-filter-config___zh",
    path: "/zh/my/collect/config/filter-config",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/config/filter-config.js")
  },
  {
    name: "section-components-broad-chart___en",
    path: "/en/section/components/broad-chart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/broad-chart.vue")
  },
  {
    name: "section-components-broad-chart___zh___default",
    path: "/section/components/broad-chart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/broad-chart.vue")
  },
  {
    name: "section-components-broad-chart___zh",
    path: "/zh/section/components/broad-chart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/broad-chart.vue")
  },
  {
    name: "section-components-hot-section___en",
    path: "/en/section/components/hot-section",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/hot-section.vue")
  },
  {
    name: "section-components-hot-section___zh___default",
    path: "/section/components/hot-section",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/hot-section.vue")
  },
  {
    name: "section-components-hot-section___zh",
    path: "/zh/section/components/hot-section",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/hot-section.vue")
  },
  {
    name: "community-components-leftSearch___en",
    path: "/en/community/components/leftSearch",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftSearch.vue")
  },
  {
    name: "community-components-leftSearch___zh___default",
    path: "/community/components/leftSearch",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftSearch.vue")
  },
  {
    name: "community-components-leftSearch___zh",
    path: "/zh/community/components/leftSearch",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftSearch.vue")
  },
  {
    name: "indexcomponents-new-index-chart___en",
    path: "/en/indexcomponents/new-index-chart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/new-index-chart.vue")
  },
  {
    name: "indexcomponents-new-index-chart___zh___default",
    path: "/indexcomponents/new-index-chart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/new-index-chart.vue")
  },
  {
    name: "indexcomponents-new-index-chart___zh",
    path: "/zh/indexcomponents/new-index-chart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/new-index-chart.vue")
  },
  {
    name: "mkt-components-platform-content___en",
    path: "/en/mkt/components/platform-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/components/platform-content.vue")
  },
  {
    name: "mkt-components-platform-content___zh___default",
    path: "/mkt/components/platform-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/components/platform-content.vue")
  },
  {
    name: "mkt-components-platform-content___zh",
    path: "/zh/mkt/components/platform-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/mkt/components/platform-content.vue")
  },
  {
    name: "community-components-commentList___en",
    path: "/en/community/components/commentList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/commentList.vue")
  },
  {
    name: "community-components-commentList___zh___default",
    path: "/community/components/commentList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/commentList.vue")
  },
  {
    name: "community-components-commentList___zh",
    path: "/zh/community/components/commentList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/commentList.vue")
  },
  {
    name: "community-components-detailTitle___en",
    path: "/en/community/components/detailTitle",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/detailTitle.vue")
  },
  {
    name: "community-components-detailTitle___zh___default",
    path: "/community/components/detailTitle",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/detailTitle.vue")
  },
  {
    name: "community-components-detailTitle___zh",
    path: "/zh/community/components/detailTitle",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/detailTitle.vue")
  },
  {
    name: "community-components-rightFooter___en",
    path: "/en/community/components/rightFooter",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightFooter.vue")
  },
  {
    name: "community-components-rightFooter___zh___default",
    path: "/community/components/rightFooter",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightFooter.vue")
  },
  {
    name: "community-components-rightFooter___zh",
    path: "/zh/community/components/rightFooter",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/rightFooter.vue")
  },
  {
    name: "indexcomponents-item-change-list___en",
    path: "/en/indexcomponents/item-change-list",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/item-change-list.vue")
  },
  {
    name: "indexcomponents-item-change-list___zh___default",
    path: "/indexcomponents/item-change-list",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/item-change-list.vue")
  },
  {
    name: "indexcomponents-item-change-list___zh",
    path: "/zh/indexcomponents/item-change-list",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/item-change-list.vue")
  },
  {
    name: "inventory-components-my-setPrice___en",
    path: "/en/inventory/components/my/setPrice",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/setPrice.vue")
  },
  {
    name: "inventory-components-my-setPrice___zh___default",
    path: "/inventory/components/my/setPrice",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/setPrice.vue")
  },
  {
    name: "inventory-components-my-setPrice___zh",
    path: "/zh/inventory/components/my/setPrice",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/setPrice.vue")
  },
  {
    name: "ladders-components-filter-drawer___en",
    path: "/en/ladders/components/filter-drawer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/filter-drawer.vue")
  },
  {
    name: "ladders-components-filter-drawer___zh___default",
    path: "/ladders/components/filter-drawer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/filter-drawer.vue")
  },
  {
    name: "ladders-components-filter-drawer___zh",
    path: "/zh/ladders/components/filter-drawer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/filter-drawer.vue")
  },
  {
    name: "my-collect-components-add-follow___en",
    path: "/en/my/collect/components/add-follow",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/add-follow.vue")
  },
  {
    name: "my-collect-components-add-follow___zh___default",
    path: "/my/collect/components/add-follow",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/add-follow.vue")
  },
  {
    name: "my-collect-components-add-follow___zh",
    path: "/zh/my/collect/components/add-follow",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/add-follow.vue")
  },
  {
    name: "my-collect-components-items-page___en",
    path: "/en/my/collect/components/items-page",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/items-page.vue")
  },
  {
    name: "my-collect-components-items-page___zh___default",
    path: "/my/collect/components/items-page",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/items-page.vue")
  },
  {
    name: "my-collect-components-items-page___zh",
    path: "/zh/my/collect/components/items-page",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/items-page.vue")
  },
  {
    name: "my-collect-components-set-remark___en",
    path: "/en/my/collect/components/set-remark",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/set-remark.vue")
  },
  {
    name: "my-collect-components-set-remark___zh___default",
    path: "/my/collect/components/set-remark",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/set-remark.vue")
  },
  {
    name: "my-collect-components-set-remark___zh",
    path: "/zh/my/collect/components/set-remark",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/set-remark.vue")
  },
  {
    name: "section-components-section-chart___en",
    path: "/en/section/components/section-chart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/section-chart.vue")
  },
  {
    name: "section-components-section-chart___zh___default",
    path: "/section/components/section-chart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/section-chart.vue")
  },
  {
    name: "section-components-section-chart___zh",
    path: "/zh/section/components/section-chart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/section-chart.vue")
  },
  {
    name: "community-components-commentInput___en",
    path: "/en/community/components/commentInput",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/commentInput.vue")
  },
  {
    name: "community-components-commentInput___zh___default",
    path: "/community/components/commentInput",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/commentInput.vue")
  },
  {
    name: "community-components-commentInput___zh",
    path: "/zh/community/components/commentInput",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/commentInput.vue")
  },
  {
    name: "community-components-deleteDialog___en",
    path: "/en/community/components/deleteDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/deleteDialog.vue")
  },
  {
    name: "community-components-deleteDialog___zh___default",
    path: "/community/components/deleteDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/deleteDialog.vue")
  },
  {
    name: "community-components-deleteDialog___zh",
    path: "/zh/community/components/deleteDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/deleteDialog.vue")
  },
  {
    name: "community-components-reportDialog___en",
    path: "/en/community/components/reportDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/reportDialog.vue")
  },
  {
    name: "community-components-reportDialog___zh___default",
    path: "/community/components/reportDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/reportDialog.vue")
  },
  {
    name: "community-components-reportDialog___zh",
    path: "/zh/community/components/reportDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/reportDialog.vue")
  },
  {
    name: "inventory-components-InventoryTop___en",
    path: "/en/inventory/components/InventoryTop",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/InventoryTop.vue")
  },
  {
    name: "inventory-components-InventoryTop___zh___default",
    path: "/inventory/components/InventoryTop",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/InventoryTop.vue")
  },
  {
    name: "inventory-components-InventoryTop___zh",
    path: "/zh/inventory/components/InventoryTop",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/InventoryTop.vue")
  },
  {
    name: "ladders-components-price-dropdown___en",
    path: "/en/ladders/components/price-dropdown",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/price-dropdown.vue")
  },
  {
    name: "ladders-components-price-dropdown___zh___default",
    path: "/ladders/components/price-dropdown",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/price-dropdown.vue")
  },
  {
    name: "ladders-components-price-dropdown___zh",
    path: "/zh/ladders/components/price-dropdown",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/price-dropdown.vue")
  },
  {
    name: "my-collect-components-add-collect___en",
    path: "/en/my/collect/components/add-collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/add-collect.vue")
  },
  {
    name: "my-collect-components-add-collect___zh___default",
    path: "/my/collect/components/add-collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/add-collect.vue")
  },
  {
    name: "my-collect-components-add-collect___zh",
    path: "/zh/my/collect/components/add-collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/add-collect.vue")
  },
  {
    name: "my-collect-components-detail-item___en",
    path: "/en/my/collect/components/detail-item",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/detail-item.vue")
  },
  {
    name: "my-collect-components-detail-item___zh___default",
    path: "/my/collect/components/detail-item",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/detail-item.vue")
  },
  {
    name: "my-collect-components-detail-item___zh",
    path: "/zh/my/collect/components/detail-item",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/detail-item.vue")
  },
  {
    name: "my-collect-components-item-manage___en",
    path: "/en/my/collect/components/item-manage",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/item-manage.vue")
  },
  {
    name: "my-collect-components-item-manage___zh___default",
    path: "/my/collect/components/item-manage",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/item-manage.vue")
  },
  {
    name: "my-collect-components-item-manage___zh",
    path: "/zh/my/collect/components/item-manage",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/item-manage.vue")
  },
  {
    name: "my-collect-components-target-tips___en",
    path: "/en/my/collect/components/target-tips",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/target-tips.vue")
  },
  {
    name: "my-collect-components-target-tips___zh___default",
    path: "/my/collect/components/target-tips",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/target-tips.vue")
  },
  {
    name: "my-collect-components-target-tips___zh",
    path: "/zh/my/collect/components/target-tips",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/target-tips.vue")
  },
  {
    name: "game-itemDetailComponents-charts___en",
    path: "/en/:game()/itemDetailComponents/charts",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/charts.vue")
  },
  {
    name: "game-itemDetailComponents-charts___zh___default",
    path: "/:game()/itemDetailComponents/charts",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/charts.vue")
  },
  {
    name: "game-itemDetailComponents-charts___zh",
    path: "/zh/:game()/itemDetailComponents/charts",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/charts.vue")
  },
  {
    name: "allnewIndexComponents-indexLadders___en",
    path: "/en/allnewIndexComponents/indexLadders",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/indexLadders.vue")
  },
  {
    name: "allnewIndexComponents-indexLadders___zh___default",
    path: "/allnewIndexComponents/indexLadders",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/indexLadders.vue")
  },
  {
    name: "allnewIndexComponents-indexLadders___zh",
    path: "/zh/allnewIndexComponents/indexLadders",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/indexLadders.vue")
  },
  {
    name: "inventory-components-InventoryInfo___en",
    path: "/en/inventory/components/InventoryInfo",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/InventoryInfo.vue")
  },
  {
    name: "inventory-components-InventoryInfo___zh___default",
    path: "/inventory/components/InventoryInfo",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/InventoryInfo.vue")
  },
  {
    name: "inventory-components-InventoryInfo___zh",
    path: "/zh/inventory/components/InventoryInfo",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/InventoryInfo.vue")
  },
  {
    name: "inventory-components-inventoryitem___en",
    path: "/en/inventory/components/inventoryitem",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/inventoryitem.vue")
  },
  {
    name: "inventory-components-inventoryitem___zh___default",
    path: "/inventory/components/inventoryitem",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/inventoryitem.vue")
  },
  {
    name: "inventory-components-inventoryitem___zh",
    path: "/zh/inventory/components/inventoryitem",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/inventoryitem.vue")
  },
  {
    name: "my-collect-components-edit-collect___en",
    path: "/en/my/collect/components/edit-collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/edit-collect.vue")
  },
  {
    name: "my-collect-components-edit-collect___zh___default",
    path: "/my/collect/components/edit-collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/edit-collect.vue")
  },
  {
    name: "my-collect-components-edit-collect___zh",
    path: "/zh/my/collect/components/edit-collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/edit-collect.vue")
  },
  {
    name: "community-components-leftPartDetail___en",
    path: "/en/community/components/leftPartDetail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftPartDetail.vue")
  },
  {
    name: "community-components-leftPartDetail___zh___default",
    path: "/community/components/leftPartDetail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftPartDetail.vue")
  },
  {
    name: "community-components-leftPartDetail___zh",
    path: "/zh/community/components/leftPartDetail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/leftPartDetail.vue")
  },
  {
    name: "indexcomponents-platformLowestPrice___en",
    path: "/en/indexcomponents/platformLowestPrice",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/platformLowestPrice.vue")
  },
  {
    name: "indexcomponents-platformLowestPrice___zh___default",
    path: "/indexcomponents/platformLowestPrice",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/platformLowestPrice.vue")
  },
  {
    name: "indexcomponents-platformLowestPrice___zh",
    path: "/zh/indexcomponents/platformLowestPrice",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/indexcomponents/platformLowestPrice.vue")
  },
  {
    name: "inventory-components-my-InventoryCS___en",
    path: "/en/inventory/components/my/InventoryCS",
    meta: InventoryCSLvbRq7sg0cHkCGWxHpSneIZ5yl7A3bUnvEur3JV4_AEMeta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/InventoryCS.vue")
  },
  {
    name: "inventory-components-my-InventoryCS___zh___default",
    path: "/inventory/components/my/InventoryCS",
    meta: InventoryCSLvbRq7sg0cHkCGWxHpSneIZ5yl7A3bUnvEur3JV4_AEMeta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/InventoryCS.vue")
  },
  {
    name: "inventory-components-my-InventoryCS___zh",
    path: "/zh/inventory/components/my/InventoryCS",
    meta: InventoryCSLvbRq7sg0cHkCGWxHpSneIZ5yl7A3bUnvEur3JV4_AEMeta || {},
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/InventoryCS.vue")
  },
  {
    name: "my-collect-components-collect-chart___en",
    path: "/en/my/collect/components/collect-chart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-chart.vue")
  },
  {
    name: "my-collect-components-collect-chart___zh___default",
    path: "/my/collect/components/collect-chart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-chart.vue")
  },
  {
    name: "my-collect-components-collect-chart___zh",
    path: "/zh/my/collect/components/collect-chart",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-chart.vue")
  },
  {
    name: "my-collect-components-follow-dialog___en",
    path: "/en/my/collect/components/follow-dialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/follow-dialog.vue")
  },
  {
    name: "my-collect-components-follow-dialog___zh___default",
    path: "/my/collect/components/follow-dialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/follow-dialog.vue")
  },
  {
    name: "my-collect-components-follow-dialog___zh",
    path: "/zh/my/collect/components/follow-dialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/follow-dialog.vue")
  },
  {
    name: "section-components-section-platform___en",
    path: "/en/section/components/section-platform",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/section-platform.vue")
  },
  {
    name: "section-components-section-platform___zh___default",
    path: "/section/components/section-platform",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/section-platform.vue")
  },
  {
    name: "section-components-section-platform___zh",
    path: "/zh/section/components/section-platform",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/section/components/section-platform.vue")
  },
  {
    name: "skindiy-components-chooseSkinDialog___en",
    path: "/en/skindiy/components/chooseSkinDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/components/chooseSkinDialog.vue")
  },
  {
    name: "skindiy-components-chooseSkinDialog___zh___default",
    path: "/skindiy/components/chooseSkinDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/components/chooseSkinDialog.vue")
  },
  {
    name: "skindiy-components-chooseSkinDialog___zh",
    path: "/zh/skindiy/components/chooseSkinDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/components/chooseSkinDialog.vue")
  },
  {
    name: "game-itemDetailComponents-saleList___en",
    path: "/en/:game()/itemDetailComponents/saleList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/saleList.vue")
  },
  {
    name: "game-itemDetailComponents-saleList___zh___default",
    path: "/:game()/itemDetailComponents/saleList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/saleList.vue")
  },
  {
    name: "game-itemDetailComponents-saleList___zh",
    path: "/zh/:game()/itemDetailComponents/saleList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/saleList.vue")
  },
  {
    name: "game-itemDetailComponents-wearRank___en",
    path: "/en/:game()/itemDetailComponents/wearRank",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/wearRank.vue")
  },
  {
    name: "game-itemDetailComponents-wearRank___zh___default",
    path: "/:game()/itemDetailComponents/wearRank",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/wearRank.vue")
  },
  {
    name: "game-itemDetailComponents-wearRank___zh",
    path: "/zh/:game()/itemDetailComponents/wearRank",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/wearRank.vue")
  },
  {
    name: "inventory-components-InventorySearch___en",
    path: "/en/inventory/components/InventorySearch",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/InventorySearch.vue")
  },
  {
    name: "inventory-components-InventorySearch___zh___default",
    path: "/inventory/components/InventorySearch",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/InventorySearch.vue")
  },
  {
    name: "inventory-components-InventorySearch___zh",
    path: "/zh/inventory/components/InventorySearch",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/InventorySearch.vue")
  },
  {
    name: "ladders-components-sellNums-dropdown___en",
    path: "/en/ladders/components/sellNums-dropdown",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/sellNums-dropdown.vue")
  },
  {
    name: "ladders-components-sellNums-dropdown___zh___default",
    path: "/ladders/components/sellNums-dropdown",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/sellNums-dropdown.vue")
  },
  {
    name: "ladders-components-sellNums-dropdown___zh",
    path: "/zh/ladders/components/sellNums-dropdown",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/sellNums-dropdown.vue")
  },
  {
    name: "my-collect-components-collect-charts___en",
    path: "/en/my/collect/components/collect-charts",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-charts.vue")
  },
  {
    name: "my-collect-components-collect-charts___zh___default",
    path: "/my/collect/components/collect-charts",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-charts.vue")
  },
  {
    name: "my-collect-components-collect-charts___zh",
    path: "/zh/my/collect/components/collect-charts",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-charts.vue")
  },
  {
    name: "my-collect-components-collect-detail___en",
    path: "/en/my/collect/components/collect-detail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-detail.vue")
  },
  {
    name: "my-collect-components-collect-detail___zh___default",
    path: "/my/collect/components/collect-detail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-detail.vue")
  },
  {
    name: "my-collect-components-collect-detail___zh",
    path: "/zh/my/collect/components/collect-detail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-detail.vue")
  },
  {
    name: "my-collect-components-collect-manage___en",
    path: "/en/my/collect/components/collect-manage",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-manage.vue")
  },
  {
    name: "my-collect-components-collect-manage___zh___default",
    path: "/my/collect/components/collect-manage",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-manage.vue")
  },
  {
    name: "my-collect-components-collect-manage___zh",
    path: "/zh/my/collect/components/collect-manage",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/collect-manage.vue")
  },
  {
    name: "my-collect-components-compare-follow___en",
    path: "/en/my/collect/components/compare-follow",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/compare-follow.vue")
  },
  {
    name: "my-collect-components-compare-follow___zh___default",
    path: "/my/collect/components/compare-follow",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/compare-follow.vue")
  },
  {
    name: "my-collect-components-compare-follow___zh",
    path: "/zh/my/collect/components/compare-follow",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/compare-follow.vue")
  },
  {
    name: "my-collect-components-create-collect___en",
    path: "/en/my/collect/components/create-collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/create-collect.vue")
  },
  {
    name: "my-collect-components-create-collect___zh___default",
    path: "/my/collect/components/create-collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/create-collect.vue")
  },
  {
    name: "my-collect-components-create-collect___zh",
    path: "/zh/my/collect/components/create-collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/create-collect.vue")
  },
  {
    name: "my-collect-components-delete-collect___en",
    path: "/en/my/collect/components/delete-collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/delete-collect.vue")
  },
  {
    name: "my-collect-components-delete-collect___zh___default",
    path: "/my/collect/components/delete-collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/delete-collect.vue")
  },
  {
    name: "my-collect-components-delete-collect___zh",
    path: "/zh/my/collect/components/delete-collect",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/delete-collect.vue")
  },
  {
    name: "my-collect-components-filter-content___en",
    path: "/en/my/collect/components/filter-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/filter-content.vue")
  },
  {
    name: "my-collect-components-filter-content___zh___default",
    path: "/my/collect/components/filter-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/filter-content.vue")
  },
  {
    name: "my-collect-components-filter-content___zh",
    path: "/zh/my/collect/components/filter-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/filter-content.vue")
  },
  {
    name: "my-collect-components-inventory-page___en",
    path: "/en/my/collect/components/inventory-page",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/inventory-page.vue")
  },
  {
    name: "my-collect-components-inventory-page___zh___default",
    path: "/my/collect/components/inventory-page",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/inventory-page.vue")
  },
  {
    name: "my-collect-components-inventory-page___zh",
    path: "/zh/my/collect/components/inventory-page",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/inventory-page.vue")
  },
  {
    name: "selection-components-mkt-valueViewer___en",
    path: "/en/selection/components/mkt-valueViewer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/components/mkt-valueViewer.vue")
  },
  {
    name: "selection-components-mkt-valueViewer___zh___default",
    path: "/selection/components/mkt-valueViewer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/components/mkt-valueViewer.vue")
  },
  {
    name: "selection-components-mkt-valueViewer___zh",
    path: "/zh/selection/components/mkt-valueViewer",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/components/mkt-valueViewer.vue")
  },
  {
    name: "game-tracker-components-trackerItem___en",
    path: "/en/:game()/tracker/components/trackerItem",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/tracker/components/trackerItem.vue")
  },
  {
    name: "game-tracker-components-trackerItem___zh___default",
    path: "/:game()/tracker/components/trackerItem",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/tracker/components/trackerItem.vue")
  },
  {
    name: "game-tracker-components-trackerItem___zh",
    path: "/zh/:game()/tracker/components/trackerItem",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/tracker/components/trackerItem.vue")
  },
  {
    name: "my-collect-components-set-targetPrice___en",
    path: "/en/my/collect/components/set-targetPrice",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/set-targetPrice.vue")
  },
  {
    name: "my-collect-components-set-targetPrice___zh___default",
    path: "/my/collect/components/set-targetPrice",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/set-targetPrice.vue")
  },
  {
    name: "my-collect-components-set-targetPrice___zh",
    path: "/zh/my/collect/components/set-targetPrice",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/set-targetPrice.vue")
  },
  {
    name: "my-collect-components-unlogin-content___en",
    path: "/en/my/collect/components/unlogin-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/unlogin-content.vue")
  },
  {
    name: "my-collect-components-unlogin-content___zh___default",
    path: "/my/collect/components/unlogin-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/unlogin-content.vue")
  },
  {
    name: "my-collect-components-unlogin-content___zh",
    path: "/zh/my/collect/components/unlogin-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/unlogin-content.vue")
  },
  {
    name: "game-itemDetailComponents-onsaleList___en",
    path: "/en/:game()/itemDetailComponents/onsaleList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/onsaleList.vue")
  },
  {
    name: "game-itemDetailComponents-onsaleList___zh___default",
    path: "/:game()/itemDetailComponents/onsaleList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/onsaleList.vue")
  },
  {
    name: "game-itemDetailComponents-onsaleList___zh",
    path: "/zh/:game()/itemDetailComponents/onsaleList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/onsaleList.vue")
  },
  {
    name: "community-components-selectTopicDialog___en",
    path: "/en/community/components/selectTopicDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/selectTopicDialog.vue")
  },
  {
    name: "community-components-selectTopicDialog___zh___default",
    path: "/community/components/selectTopicDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/selectTopicDialog.vue")
  },
  {
    name: "community-components-selectTopicDialog___zh",
    path: "/zh/community/components/selectTopicDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/community/components/selectTopicDialog.vue")
  },
  {
    name: "inventory-components-myinventory___en",
    path: "/en/inventory/components/myinventory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/index.vue")
  },
  {
    name: "inventory-components-myinventory___zh___default",
    path: "/inventory/components/myinventory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/index.vue")
  },
  {
    name: "inventory-components-myinventory___zh",
    path: "/zh/inventory/components/myinventory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/index.vue")
  },
  {
    name: "ladders-components-ladders-lowestPrice___en",
    path: "/en/ladders/components/ladders-lowestPrice",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/ladders-lowestPrice.vue")
  },
  {
    name: "ladders-components-ladders-lowestPrice___zh___default",
    path: "/ladders/components/ladders-lowestPrice",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/ladders-lowestPrice.vue")
  },
  {
    name: "ladders-components-ladders-lowestPrice___zh",
    path: "/zh/ladders/components/ladders-lowestPrice",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/ladders-lowestPrice.vue")
  },
  {
    name: "my-collect-components-detail-item-list___en",
    path: "/en/my/collect/components/detail-item-list",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/detail-item-list.vue")
  },
  {
    name: "my-collect-components-detail-item-list___zh___default",
    path: "/my/collect/components/detail-item-list",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/detail-item-list.vue")
  },
  {
    name: "my-collect-components-detail-item-list___zh",
    path: "/zh/my/collect/components/detail-item-list",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/detail-item-list.vue")
  },
  {
    name: "my-collect-components-itemCollect-list___en",
    path: "/en/my/collect/components/itemCollect-list",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/itemCollect-list.vue")
  },
  {
    name: "my-collect-components-itemCollect-list___zh___default",
    path: "/my/collect/components/itemCollect-list",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/itemCollect-list.vue")
  },
  {
    name: "my-collect-components-itemCollect-list___zh",
    path: "/zh/my/collect/components/itemCollect-list",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/itemCollect-list.vue")
  },
  {
    name: "skindiy-components-chooseStickerDialog___en",
    path: "/en/skindiy/components/chooseStickerDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/components/chooseStickerDialog.vue")
  },
  {
    name: "skindiy-components-chooseStickerDialog___zh___default",
    path: "/skindiy/components/chooseStickerDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/components/chooseStickerDialog.vue")
  },
  {
    name: "skindiy-components-chooseStickerDialog___zh",
    path: "/zh/skindiy/components/chooseStickerDialog",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/skindiy/components/chooseStickerDialog.vue")
  },
  {
    name: "inventory-components-my-setPriceHistory___en",
    path: "/en/inventory/components/my/setPriceHistory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/setPriceHistory.vue")
  },
  {
    name: "inventory-components-my-setPriceHistory___zh___default",
    path: "/inventory/components/my/setPriceHistory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/setPriceHistory.vue")
  },
  {
    name: "inventory-components-my-setPriceHistory___zh",
    path: "/zh/inventory/components/my/setPriceHistory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/setPriceHistory.vue")
  },
  {
    name: "inventory-components-SevenDaysInventory___en",
    path: "/en/inventory/components/SevenDaysInventory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/SevenDaysInventory.vue")
  },
  {
    name: "inventory-components-SevenDaysInventory___zh___default",
    path: "/inventory/components/SevenDaysInventory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/SevenDaysInventory.vue")
  },
  {
    name: "inventory-components-SevenDaysInventory___zh",
    path: "/zh/inventory/components/SevenDaysInventory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/SevenDaysInventory.vue")
  },
  {
    name: "selection-components-addFilterCondition___en",
    path: "/en/selection/components/addFilterCondition",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/components/addFilterCondition.vue")
  },
  {
    name: "selection-components-addFilterCondition___zh___default",
    path: "/selection/components/addFilterCondition",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/components/addFilterCondition.vue")
  },
  {
    name: "selection-components-addFilterCondition___zh",
    path: "/zh/selection/components/addFilterCondition",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/selection/components/addFilterCondition.vue")
  },
  {
    name: "game-itemDetailComponents-item-tracker___en",
    path: "/en/:game()/itemDetailComponents/item-tracker",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/item-tracker.vue")
  },
  {
    name: "game-itemDetailComponents-item-tracker___zh___default",
    path: "/:game()/itemDetailComponents/item-tracker",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/item-tracker.vue")
  },
  {
    name: "game-itemDetailComponents-item-tracker___zh",
    path: "/zh/:game()/itemDetailComponents/item-tracker",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/item-tracker.vue")
  },
  {
    name: "game-itemDetailComponents-transication___en",
    path: "/en/:game()/itemDetailComponents/transication",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/transication.vue")
  },
  {
    name: "game-itemDetailComponents-transication___zh___default",
    path: "/:game()/itemDetailComponents/transication",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/transication.vue")
  },
  {
    name: "game-itemDetailComponents-transication___zh",
    path: "/zh/:game()/itemDetailComponents/transication",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/transication.vue")
  },
  {
    name: "inventory-components-my-inventoryChanges___en",
    path: "/en/inventory/components/my/inventoryChanges",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/inventoryChanges.vue")
  },
  {
    name: "inventory-components-my-inventoryChanges___zh___default",
    path: "/inventory/components/my/inventoryChanges",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/inventoryChanges.vue")
  },
  {
    name: "inventory-components-my-inventoryChanges___zh",
    path: "/zh/inventory/components/my/inventoryChanges",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/inventoryChanges.vue")
  },
  {
    name: "ladders-components-ladder-center-content___en",
    path: "/en/ladders/components/ladder-center-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/ladder-center-content.vue")
  },
  {
    name: "ladders-components-ladder-center-content___zh___default",
    path: "/ladders/components/ladder-center-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/ladder-center-content.vue")
  },
  {
    name: "ladders-components-ladder-center-content___zh",
    path: "/zh/ladders/components/ladder-center-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/ladder-center-content.vue")
  },
  {
    name: "ladders-components-swap-platform-compare___en",
    path: "/en/ladders/components/swap-platform-compare",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/swap-platform-compare.vue")
  },
  {
    name: "ladders-components-swap-platform-compare___zh___default",
    path: "/ladders/components/swap-platform-compare",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/swap-platform-compare.vue")
  },
  {
    name: "ladders-components-swap-platform-compare___zh",
    path: "/zh/ladders/components/swap-platform-compare",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/swap-platform-compare.vue")
  },
  {
    name: "ladders-components-transication-dropdown___en",
    path: "/en/ladders/components/transication-dropdown",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/transication-dropdown.vue")
  },
  {
    name: "ladders-components-transication-dropdown___zh___default",
    path: "/ladders/components/transication-dropdown",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/transication-dropdown.vue")
  },
  {
    name: "ladders-components-transication-dropdown___zh",
    path: "/zh/ladders/components/transication-dropdown",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/ladders/components/transication-dropdown.vue")
  },
  {
    name: "my-collect-components-detail-target-tips___en",
    path: "/en/my/collect/components/detail-target-tips",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/detail-target-tips.vue")
  },
  {
    name: "my-collect-components-detail-target-tips___zh___default",
    path: "/my/collect/components/detail-target-tips",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/detail-target-tips.vue")
  },
  {
    name: "my-collect-components-detail-target-tips___zh",
    path: "/zh/my/collect/components/detail-target-tips",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/detail-target-tips.vue")
  },
  {
    name: "game-itemDetailComponents-detail-header___en",
    path: "/en/:game()/itemDetailComponents/detail-header",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/detail-header.vue")
  },
  {
    name: "game-itemDetailComponents-detail-header___zh___default",
    path: "/:game()/itemDetailComponents/detail-header",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/detail-header.vue")
  },
  {
    name: "game-itemDetailComponents-detail-header___zh",
    path: "/zh/:game()/itemDetailComponents/detail-header",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/detail-header.vue")
  },
  {
    name: "game-itemDetailComponents-price-content___en",
    path: "/en/:game()/itemDetailComponents/price-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/price-content.vue")
  },
  {
    name: "game-itemDetailComponents-price-content___zh___default",
    path: "/:game()/itemDetailComponents/price-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/price-content.vue")
  },
  {
    name: "game-itemDetailComponents-price-content___zh",
    path: "/zh/:game()/itemDetailComponents/price-content",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/price-content.vue")
  },
  {
    name: "inventory-components-my-historicalPositions___en",
    path: "/en/inventory/components/my/historicalPositions",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/historicalPositions.vue")
  },
  {
    name: "inventory-components-my-historicalPositions___zh___default",
    path: "/inventory/components/my/historicalPositions",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/historicalPositions.vue")
  },
  {
    name: "inventory-components-my-historicalPositions___zh",
    path: "/zh/inventory/components/my/historicalPositions",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/my/historicalPositions.vue")
  },
  {
    name: "game-itemDetailComponents-transactionDetail___en",
    path: "/en/:game()/itemDetailComponents/transactionDetail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/transactionDetail.vue")
  },
  {
    name: "game-itemDetailComponents-transactionDetail___zh___default",
    path: "/:game()/itemDetailComponents/transactionDetail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/transactionDetail.vue")
  },
  {
    name: "game-itemDetailComponents-transactionDetail___zh",
    path: "/zh/:game()/itemDetailComponents/transactionDetail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/[game]/itemDetailComponents/transactionDetail.vue")
  },
  {
    name: "allnewIndexComponents-indexLadder-collectList___en",
    path: "/en/allnewIndexComponents/indexLadder-collectList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/indexLadder-collectList.vue")
  },
  {
    name: "allnewIndexComponents-indexLadder-collectList___zh___default",
    path: "/allnewIndexComponents/indexLadder-collectList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/indexLadder-collectList.vue")
  },
  {
    name: "allnewIndexComponents-indexLadder-collectList___zh",
    path: "/zh/allnewIndexComponents/indexLadder-collectList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/indexLadder-collectList.vue")
  },
  {
    name: "allnewIndexComponents-indexLadder-hangingList___en",
    path: "/en/allnewIndexComponents/indexLadder-hangingList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/indexLadder-hangingList.vue")
  },
  {
    name: "allnewIndexComponents-indexLadder-hangingList___zh___default",
    path: "/allnewIndexComponents/indexLadder-hangingList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/indexLadder-hangingList.vue")
  },
  {
    name: "allnewIndexComponents-indexLadder-hangingList___zh",
    path: "/zh/allnewIndexComponents/indexLadder-hangingList",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/allnewIndexComponents/indexLadder-hangingList.vue")
  },
  {
    name: "inventory-components-myinventory-cs2Inventory___en",
    path: "/en/inventory/components/myinventory/cs2Inventory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/cs2Inventory.vue")
  },
  {
    name: "inventory-components-myinventory-cs2Inventory___zh___default",
    path: "/inventory/components/myinventory/cs2Inventory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/cs2Inventory.vue")
  },
  {
    name: "inventory-components-myinventory-cs2Inventory___zh",
    path: "/zh/inventory/components/myinventory/cs2Inventory",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/cs2Inventory.vue")
  },
  {
    name: "inventory-components-SevenDaysInventoryDetail___en",
    path: "/en/inventory/components/SevenDaysInventoryDetail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/SevenDaysInventoryDetail.vue")
  },
  {
    name: "inventory-components-SevenDaysInventoryDetail___zh___default",
    path: "/inventory/components/SevenDaysInventoryDetail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/SevenDaysInventoryDetail.vue")
  },
  {
    name: "inventory-components-SevenDaysInventoryDetail___zh",
    path: "/zh/inventory/components/SevenDaysInventoryDetail",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/SevenDaysInventoryDetail.vue")
  },
  {
    name: "my-collect-components-inventory-collect-manage___en",
    path: "/en/my/collect/components/inventory-collect-manage",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/inventory-collect-manage.vue")
  },
  {
    name: "my-collect-components-inventory-collect-manage___zh___default",
    path: "/my/collect/components/inventory-collect-manage",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/inventory-collect-manage.vue")
  },
  {
    name: "my-collect-components-inventory-collect-manage___zh",
    path: "/zh/my/collect/components/inventory-collect-manage",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/my/collect/components/inventory-collect-manage.vue")
  },
  {
    name: "inventory-components-myinventory-inventoryChanges___en",
    path: "/en/inventory/components/myinventory/inventoryChanges",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/inventoryChanges.vue")
  },
  {
    name: "inventory-components-myinventory-inventoryChanges___zh___default",
    path: "/inventory/components/myinventory/inventoryChanges",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/inventoryChanges.vue")
  },
  {
    name: "inventory-components-myinventory-inventoryChanges___zh",
    path: "/zh/inventory/components/myinventory/inventoryChanges",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/inventoryChanges.vue")
  },
  {
    name: "inventory-components-myinventory-historicalPositions___en",
    path: "/en/inventory/components/myinventory/historicalPositions",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/historicalPositions.vue")
  },
  {
    name: "inventory-components-myinventory-historicalPositions___zh___default",
    path: "/inventory/components/myinventory/historicalPositions",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/historicalPositions.vue")
  },
  {
    name: "inventory-components-myinventory-historicalPositions___zh",
    path: "/zh/inventory/components/myinventory/historicalPositions",
    component: () => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/pages/inventory/components/myinventory/historicalPositions.vue")
  }
]